import { IconSvg } from 'shared/icon';
import { ReactNode } from 'react';
import { StyledBorderedInfo, StyledBorderedInfoText } from './Info.styled';

interface InfoProps {
  content: ReactNode;
  width?: string | number;
  isInline?: boolean;
  hasBg?: boolean;
  marginTop?: boolean;
  noMarginBottom?: boolean;
}

const Info = ({
  content, width = 'auto', isInline = false, hasBg = false, marginTop = false, noMarginBottom = false,
}: InfoProps) => (
  <StyledBorderedInfo $width={width} $isInline={isInline} $hasBg={hasBg} $marginTop={marginTop} $noMarginBottom={noMarginBottom}>
    <IconSvg icon="InfoIcon" width="1.28rem" height="1.14rem" />
    <StyledBorderedInfoText>{content}</StyledBorderedInfoText>
  </StyledBorderedInfo>
);

export default Info;
